import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import API from "src/API2";
import { UPLOAD_URL } from "src/constants";
import "./homeslidermanager.css";



const NewSlideModal = ({ setActive }) => {
  const [title, setTitle] = useState("");
  const [buttonTitle, setButtonTitle] = useState("");
  const [buttonLink, setButtonLink] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState(null);
  const ref = useRef();

  const post = () => {
    const form = new FormData();
    form.append("title", title);
    form.append("description", description);
    form.append("button_content", buttonTitle);
    form.append("button_link", buttonLink);
    form.append("pictures", images[0]);

    toast.promise(
      API.post("content/slide", form).then(() => {
        window.location.reload();
      }),
      {
        success: "Slide created succeffully.",
        loading: "Creating Slide.",
        error: "Something went wrong, Check your inputs and try again.",
      }
    );
  };

  return (
    <div className="newslidemodal">
      <div className="wrapperblur">
        <div className="content">
          <div className="input">
            <span>Title</span>
            <input
              placeholder="Slide title"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </div>
          <div className="inline_inputs">
            <div className="input">
              <span>Button Title</span>
              <input
                placeholder="Slide button title"
                value={buttonTitle}
                onChange={(e) => {
                  setButtonTitle(e.target.value);
                }}
              />
            </div>
            <div className="input">
              <span>Button Link</span>
              <input
                placeholder="Slide button link"
                value={buttonLink}
                onChange={(e) => {
                  setButtonLink(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="input">
            <span>Description</span>
            <textarea
              placeholder="Slide description"
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
            />
          </div>
          <div className="image_input">
            {images ? (
              <img
                src={URL.createObjectURL(images[0])}
                className="left"
                alt="Preview"
              />
            ) : (
              <div className="left"></div>
            )}
            <div className="right">
              <span>Select the slide picture</span>
              <div
                className="full_button"
                onClick={() => {
                  ref.current.click();
                }}
              >
                Browse
              </div>
            </div>
            <input
              type="file"
              style={{ display: "none" }}
              ref={ref}
              onChange={(e) => {
                setImages(e.target.files);
              }}
            />
          </div>
          <div className="buttons">
            <div
              className="outlined_button"
              onClick={() => {
                setActive(false);
              }}
            >
              Cancel
            </div>
            <div
              className="full_button"
              onClick={() => {
                post();
              }}
            >
              Create
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const HomeSliderManger = () => {
  const [active, setActive] = useState(false);
  const [slides, setSlides] = useState([]);


  useEffect(() => {
    toast.promise(
      API.get("content/slide").then((resp) => {
        setSlides(resp.data.slides);
      }),
      {
        success: "Slides fetched succeffully",
        loading: "Fetching slides",
        error: "Something went wrong, try again later",
      }
    );
  }, []);

  return (
    <div className="homeslidermanager">
      {active && <NewSlideModal setActive={setActive} />}
      <div className="current_slides">
        <div className="top">
          <h3>Current Slides</h3>
          <div
            className="full_button"
            onClick={() => {
              setActive(true);
            }}
          >
            Add new Slide
          </div>
        </div>

        <div className="slides_images">
          {slides.length === 0 ? (
            <>No slides found ...</>
          ) : (
            slides.map((e, i) => {
              console.log(e);
              return (
                <div className="slide_image">
                  <img
                    src={UPLOAD_URL[process.env.NODE_ENV] + e.picture.filename}
                    alt="slide"
                  />
                  <div className="editdelete">
                    <div
                      className="delete_slide"
                      onDoubleClick={() => {
                        toast.promise(
                          API.delete("content/slide/" + e.id).then(
                            setSlides((prev) =>
                              prev.filter((k) => k.id !== e.id)
                            )
                          ),
                          {
                            success: "Slide deleted succeffuly",
                            error: "Something went wrong",
                            loading: "Deleting the Slide",
                          }
                        );
                      }}
                    >
                      Delete
                    </div>
                    <div className="edit_slide">Edit</div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeSliderManger;
